// Generic helper functions
export const openUrl = (url) => {
  if (!window || !url) return;
  window.open(url, '_blank');
};

export const openDomainUrl = (domain) => {
  if (!domain) return;
  let url = domain.includes('https://') ? domain : `https://${domain}`;
  if (!url.includes('www.')) {
    url = url.replace('https://', 'https://www.');
  }
  openUrl(url);
};

/**
 * Abre URL do servidor (IP). suffixOrPort opcional: number = porta (http://ip:port),
 * string = path suffix (http://ip/suffix), omitido = http://ip
 */
export const openServerIpUrl = (serverIp, suffixOrPort, protocol = 'http') => {
  if (!serverIp) return;
  const url = typeof suffixOrPort === 'number'
    ? `${protocol}://${serverIp}:${suffixOrPort}`
    : `${protocol}://${serverIp}${suffixOrPort || ''}`;
  openUrl(url);
};

export const snapshotRedirect = (productId, locale) => {
  if (!productId || !locale) return;
  const url = `${locale('routes.products')}${locale('routes.productdetail')}/${productId}${locale('routes.snapshots')}`;
  openUrl(url);
};

const PLESK_ADMIN_PATH = '/admin';
const CYBERPANEL_PORT = 8090;
const SUPABASE_PORT = 8000;
const KUBERNETES_SSLIP_SUFFIX = '.sslip.io';
const EASYPANEL_PORT = 3000;
const WEBMIN_PORT = 10000;
const VIRTUALMIN_PORT = 10000;
const OPENCLAW_PORT = 47716;
const GATORCLAW_PORT = 47716;

export const Management = {
  backupRedirect: (productId, locale) => {
    if (!productId || !locale) return;
    const url = `${locale('routes.products')}${locale('routes.productdetail')}/${productId}${locale('routes.backup')}`;
    openUrl(url);
  },
  sshKeysRedirect: (productId, locale) => {
    if (!productId || !locale) return;
    const url = `${locale('routes.products')}${locale('routes.productdetail')}/${productId}${locale('routes.sshKeys')}`;
    openUrl(url);
  },
  cpanelRedirect: (productId, locale) => {
    if (!productId || !locale) return;
    const url = `${locale('routes.whmRedirectAccess')}/${productId}`;
    openUrl(url);
  },
  pleskRedirect: serverIp => openServerIpUrl(serverIp, PLESK_ADMIN_PATH),
  dockerRedirect: serverIp => openServerIpUrl(serverIp),
  moodleRedirect: serverIp => openServerIpUrl(serverIp),
  nodejsRedirect: serverIp => openServerIpUrl(serverIp),
  woocommerceRedirect: domain => openDomainUrl(domain),
  pterodactylRedirect: serverIp => openServerIpUrl(serverIp),
  laravelRedirect: serverIp => openServerIpUrl(serverIp),
  cyberPanelRedirect: serverIp => openServerIpUrl(serverIp, CYBERPANEL_PORT),
  magentoRedirect: domain => openDomainUrl(domain),
  supabaseRedirect: serverIp => openServerIpUrl(serverIp, SUPABASE_PORT),
  kubernetesRedirect: serverIp => openServerIpUrl(serverIp, KUBERNETES_SSLIP_SUFFIX),
  easyPanelRedirect: serverIp => openServerIpUrl(serverIp, EASYPANEL_PORT),
  webminRedirect: serverIp => openServerIpUrl(serverIp, WEBMIN_PORT),
  virtualminRedirect: serverIp => openServerIpUrl(serverIp, VIRTUALMIN_PORT),
  openClawRedirect: serverIp => openServerIpUrl(serverIp, OPENCLAW_PORT),
  gatorClawRedirect: serverIp => openServerIpUrl(serverIp, GATORCLAW_PORT),
  evolutionGoRedirect: serverIp => openServerIpUrl(serverIp, '', 'https'),
  evolutionApiRedirect: serverIp => openServerIpUrl(serverIp, '', 'https'),
};
